<div id="layout" class="f_col">
  <app-view-title fromRoute="pre-enroll" [chooseLangBtn]="false">{{'meansPayment.title' | translate}}</app-view-title>
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_scroll-wrapper_l resp_c-50">
      <app-view-deco-image class="mb_20" imageUrl="assets-projects/images/image_payment.svg"></app-view-deco-image>
      <app-snackbar *ngIf="cart?.cartDatas?.fromRoute === 'person'" Icon="check" class="mb_10 f_center">{{cart?.actualPerson?.firstName + ' ' + cart?.actualPerson?.lastName}}</app-snackbar>
      <app-desc-card class="mb_10" leftIcon="shopping-cart" descL="{{cart?.actualDocument?.amountCents / 100 + ' ' + CurrencySign[cart.actualDocument?.currency]}}" descR1="{{cart?.actualPerson?.firstName + ' ' + cart?.actualPerson?.lastName}}" descR2="{{cart?.actualDocument?.id + '.title' | translate}}"></app-desc-card>
      <div class="mb_40">
        <div *ngIf="!device.isDevices('cordova')">
          <app-slide-element leftIcon="credit-card" (btnClicked)="payByPaypal()" class="mb_10">
            {{'onlinePayment.title' | translate}}
          </app-slide-element>
        </div>
      </div>

      <div class="resp_minSize_l mb_20 mt_20 flex gap_10">
        <app-button size="xsm" color="transparent" border="true" class="fullWidth" (btnClicked)="nav.to('camera-payment')">
          {{'global.back' | translate}}
        </app-button>
      </div>
    </div>
  </div>

  <div class="f_align_end mb_20 resp_maxSize_l">
    <app-back-btn class="mr_10" icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    <app-back-btn (btnClicked)="nav.to('camera-payment')"></app-back-btn>
  </div>
</div>

